import React from 'react';
import styles from './ProgressBar.module.scss';

interface IProgressBarProps {
  percentage: number; // 0-100
  showPercentage?: boolean; // Display % text on bar
  height?: string; // Default: "32px"
  color?: string; // Override color
}

const ProgressBar: React.FC<IProgressBarProps> = ({
  percentage,
  showPercentage = true,
  height = '25px',
  color,
}) => {
  // Cap percentage at 100%
  const cappedPercentage = Math.min(Math.max(percentage, 0), 100);

  // Always use dark orange (Eagerdog brand color)
  const barColor = color || '#F25A2D';

  return (
    <div className={styles.progressBarContainer} style={{ height }}>
      <div
        className={styles.progressBarFill}
        style={{
          width: `${cappedPercentage}%`,
          backgroundColor: barColor,
          height,
        }}
      >
        {showPercentage && cappedPercentage > 0 && (
          <span className={styles.percentageText}>
            {Math.round(cappedPercentage)}%
          </span>
        )}
      </div>
    </div>
  );
};

export default ProgressBar;

